export default __webpack_public_path__ + "static/media/ic-faq.88f34ff0.svg";